import { render, staticRenderFns } from "./AccordionToggle.vue?vue&type=template&id=0de62a5a&"
import script from "./AccordionToggle.vue?vue&type=script&lang=js&"
export * from "./AccordionToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports